import {
  SECTIONS_LOADED,
  DEFAULT_ROUTES_LOADED,
  SECTIONS_DEPOT_STATS_LOADED,
} from "../actions/sections";

const initialState = {
  sections: {},
  defaultRoutes: {},
  depotStats: {},
};

const sectionsData = (state = initialState, action) => {
  switch (action.type) {
    case SECTIONS_LOADED:
      return {
        ...state,
        sections: action.payload,
      };
    case DEFAULT_ROUTES_LOADED:
      return {
        ...state,
        defaultRoutes: action.payload,
      };
    case SECTIONS_DEPOT_STATS_LOADED:
      return {
        ...state,
        depotStats: action.payload,
      };
    default:
      return state;
  }
};

export default sectionsData;
